import axios from 'axios';

export default{
  //  团队介绍
  //团队介绍保存
  saveTeam(data) {
    return axios.post('/sale/team/save',data);
  },
  //获取团队介绍
  getTeam() {
    return axios.get('/sale/team/list');
  },
  //删除团队介绍
  delTeam(data) {
    return axios.post('/sale/team/delete',data);
  },


  
  //获取组织架构图
  getStationList() {
    return axios.get('/sale/team/stationList');
  },
  //保存组织架构图
  saveStations(data) {
    return axios.post('/sale/team/saveStations',data);
  },
  //删除组织架构图
  deleteStations(data) {
    return axios.post('/sale/team/deleteStations',data);
  },


  
  //  销量排名
  //销量排名保存
  saveOrder(data) {
    return axios.post('/sale/order/save',data);
  },
  //获取销量排名
  getOrder() {
    return axios.get('/sale/order/list');
  },
  //删除销量排名
  delOrder(data) {
    return axios.post('/sale/order/delete',data);
  },



  //  销售提示
  //销售提示保存
  saveNotify(data) {
    return axios.post('/sale/notify/save',data);
  },
  //获取销售提示
  getNotify() {
    return axios.get('/sale/notify/list');
  },
  //获取销售提示详情
  getNotifyDetail(data) {
    return axios.get('/sale/notify/info/'+data);
  },
  //删除销售提示
  delNotify(data) {
    return axios.post('/sale/notify/delete',data);
  },



  //  销售网络
  //销售网络保存
  saveConfig(data) {
    return axios.post('/sale/conf/save',data);
  },
  //获取销售网络
  getConfig() {
    return axios.get('/sale/conf/list');
  },



    //  业绩趋势
  //业绩趋势保存
  saveAchieve(data) {
    return axios.post('/sale/achieve/save',data);
  },
  //获取业绩趋势
  getAchieve() {
    return axios.get('/sale/achieve/list');
  },
  //获取业绩趋势下面
  getAchieveDown() {
    return axios.get('/sale/achieve/faceList');
  },
  //删除业绩趋势
  delAchieve(data) {
    return axios.post('/sale/achieve/delete',data);
  },



    //  区域对比
  //区域对比保存
  saveArea(data) {
    return axios.post('/sale/area/save',data);
  },
  //获取区域对比
  getArea() {
    return axios.get('/sale/area/list');
  },
  //删除区域对比
  delArea(data) {
    return axios.post('/sale/area/delete',data);
  },



    //  销售明星
  //销售明星保存
  saveStar(data) {
    return axios.post('/sale/star/save',data);
  },
  //获取销售明星
  getStar() {
    return axios.get('/sale/star/list');
  },
  //删除销售明星
  delStar(data) {
    return axios.post('/sale/star/delete',data);
  },




    //  团队风采
  //团队风采保存
  saveActive(data) {
    return axios.post('/sale/active/save',data);
  },
  //获取团队风采
  getActive() {
    return axios.get('/sale/active/list');
  },
  //删除团队风采
  delActive(data) {
    return axios.post('/sale/active/delete',data);
  },





    //  重点客户
  //重点客户保存
  savePartner(data) {
    return axios.post('/sale/partner/save',data);
  },
  //获取重点客户
  getPartner() {
    return axios.get('/sale/partner/list?limit=20&page=1');
  },
  //删除重点客户
  delPartner(data) {
    return axios.post('/sale/partner/delete',data);
  },




    //  渠道分布
  //渠道分布保存
  saveChannel(data) {
    return axios.post('/sale/channel/save',data);
  },
  //获取渠道分布
  getChannel() {
    return axios.get('/sale/channel/list');
  },
}